export default function({ state, commit, dispatch }, { id, patient, provider, updateObj}) {
    return dispatch('patch', {
        url: '/provider/' + ( state.id ? state.id : provider ) + '/patient/' + patient + '/assessment/' + id,
        data: updateObj
    }, {
        root: true
    })
    .then((response) => {
        return response
    })
    .catch((error) => {
        throw error
    })
}

